<ng-container *ngIf="isVisible">
  <div class="full-panel-container absolute left-14 z-500 w-full h-full" style="width: calc(100% - 56px)" @openClose>
    <ng-container *ngTemplateOutlet="currentTemplate"></ng-container>
  </div>
</ng-container>
